<div appFormControl class="text">
  <input
    (blur)="onBlur()"
    (focus)="onFocus()"
    [attr.required]="required"
    [formControl]="control"
    [id]="id"
    [name]="name"
    [placeholder]="placeholder()"
    appFormRestrictedCharacters
    class="text__input"
    type="text"
  />
  @if (control.touched && control.enabled) {
    <app-validity-icon
      [valid]="control.valid && control.value"
      class="text__input-check-icon"
    />
  }
</div>
